(function () {
  var CFG = window.MOLVERE || {};
  var SEUIL_LIVRAISON = CFG.seuilLivraison || 6000;
  var SEUIL_CADEAU = CFG.seuilCadeau || 12000;
  var GIFT_ID = parseInt(CFG.giftVariantId, 10) || 0;
  var dejaGagne = false;
  var giftEnCours = false;

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  window.cartOpen = function (e) {
    if (e) e.preventDefault();
    document.getElementById('cart').classList.add('on');
    document.getElementById('cart-overlay').classList.add('on');
    document.body.style.overflow = 'hidden';
    cartRefresh();
  };

  window.cartClose = function () {
    document.getElementById('cart').classList.remove('on');
    document.getElementById('cart-overlay').classList.remove('on');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.cartClose();
  });

  function cartRefresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { return gererCadeau(cart); })
      .then(function (cart) { render(cart); })
      .catch(function (err) { console.error('Panier :', err); });
  }
  window.cartRefresh = cartRefresh;

  function gererCadeau(cart) {
    if (!GIFT_ID) return Promise.resolve(cart);

    var sousTotal = 0;
    var giftLine = null;
    cart.items.forEach(function (it) {
      if (it.variant_id === GIFT_ID) { giftLine = it; }
      else { sousTotal += it.final_line_price; }
    });

    if (sousTotal >= SEUIL_CADEAU && !giftLine && !giftEnCours) {
      giftEnCours = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: GIFT_ID, quantity: 1 })
      }).then(function () {
        giftEnCours = false;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).catch(function () { giftEnCours = false; return cart; });
    }

    if (sousTotal < SEUIL_CADEAU && giftLine && !giftEnCours) {
      giftEnCours = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      }).then(function (r) { giftEnCours = false; return r.json(); })
        .catch(function () { giftEnCours = false; return cart; });
    }

    return Promise.resolve(cart);
  }

  function render(cart) {
    var wrap = document.getElementById('cart-items');
    if (!wrap) return;

    var sousTotal = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id !== GIFT_ID) sousTotal += it.final_line_price;
    });

    if (cart.items.length === 0) {
      wrap.innerHTML = '<div class="cart__empty">Ton panier est vide.<br>Le drop t\u2019attend.</div>';
    } else {
      wrap.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="' + it.product_title.replace(/"/g, '&quot;') + '" loading="lazy">'
          : '';
        var variante = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';

        if (GIFT_ID && it.variant_id === GIFT_ID) {
          return '<div class="cart__item cadeau">' +
            '<div class="cart__thumb">' + img + '</div>' +
            '<div class="cart__info">' +
              '<div><span class="cart__gratuit">Offert</span></div>' +
              '<div class="cart__name">' + it.product_title + '</div>' +
              (variante ? '<div class="cart__variant">' + variante + '</div>' : '') +
              '<div class="cart__row"><div></div>' +
                '<div class="cart__price">' + (it.original_line_price > 0 ? '<s>' + euros(it.original_line_price) + '</s>' : '') + euros(it.final_line_price) + '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
        }

        return '<div class="cart__item">' +
          '<div class="cart__thumb">' + img + '</div>' +
          '<div class="cart__info">' +
            '<div class="cart__name">' + it.product_title + '</div>' +
            (variante ? '<div class="cart__variant">' + variante + '</div>' : '') +
            '<div class="cart__row">' +
              '<div class="cart__qty">' +
                '<button onclick="cartQty(\'' + it.key + '\',' + (it.quantity - 1) + ')" aria-label="R\u00e9duire">\u2212</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button onclick="cartQty(\'' + it.key + '\',' + (it.quantity + 1) + ')" aria-label="Augmenter">+</button>' +
              '</div>' +
              '<div class="cart__price">' + euros(it.final_line_price) + '</div>' +
            '</div>' +
            '<button class="cart__remove" onclick="cartQty(\'' + it.key + '\',0)">Retirer</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    var count = document.getElementById('cart-count');
    if (count) count.textContent = cart.item_count;
    var subEl = document.getElementById('cart-subtotal');
    if (subEl) subEl.textContent = euros(cart.total_price);

    var shipTxt = document.getElementById('ship-txt');
    var fill = document.getElementById('ship-fill');
    var runner = document.getElementById('ship-runner');
    var zone = document.getElementById('ship-zone');
    var stepL = document.getElementById('step-livraison');
    var stepC = document.getElementById('step-cadeau');
    if (!shipTxt) return;

    var pct = Math.min(100, (sousTotal / SEUIL_CADEAU) * 100);
    fill.style.width = pct + '%';
    runner.style.left = pct + '%';
    stepL.classList.toggle('ok', sousTotal >= SEUIL_LIVRAISON);
    stepC.classList.toggle('ok', sousTotal >= SEUIL_CADEAU);
    runner.classList.toggle('fini', sousTotal >= SEUIL_CADEAU);

    if (sousTotal >= SEUIL_CADEAU) {
      shipTxt.innerHTML = '<strong>\uD83C\uDF89 Livraison offerte + ton 3\u1D49 article OFFERT est dans le panier</strong>';
      if (!dejaGagne) {
        zone.classList.remove('gagne');
        void zone.offsetWidth;
        zone.classList.add('gagne');
        dejaGagne = true;
      }
    } else if (sousTotal >= SEUIL_LIVRAISON) {
      dejaGagne = false;
      shipTxt.innerHTML = '<strong>Livraison offerte d\u00e9bloqu\u00e9e \u2713</strong> \u2014 plus que <strong>' +
        euros(SEUIL_CADEAU - sousTotal) + '</strong> pour ton 3\u1D49 article offert';
    } else {
      dejaGagne = false;
      shipTxt.innerHTML = 'Plus que <strong>' + euros(SEUIL_LIVRAISON - sousTotal) +
        '</strong> pour la livraison offerte';
    }
  }

  window.cartQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return gererCadeau(cart); })
      .then(function (cart) { render(cart); })
      .catch(function (err) { console.error('Panier :', err); });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.txt = btn.textContent; btn.textContent = 'Ajout\u2026'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.txt; }
        window.cartOpen();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.txt; }
        alert('Impossible d\u2019ajouter cet article. R\u00e9essaie.');
      });
  });

  document.addEventListener('DOMContentLoaded', cartRefresh);
})();
